import React from 'react';
import {
  Typography,
  Grid,
  Button,
} from '@material-ui/core';
import color from '@material-ui/core/colors/amber';

const Footer = () => (
  <footer>
    <div className="info">
      <div className="container">
        <Grid container spacing={32} justify="space-evenly">
          <Grid item xs={12} sm>
            <img
              src="./BloodyBattle-logo-footer.png"
              alt="BloodyBattle"
              width="250px"
              style={{ marginButton: '8px' }}
            />
            <Typography paragraph variant="body2" color="inherit">
              <i>Passez de bons moments ensemble.<br />Merci pour votre soutien!</i>
            </Typography>
          </Grid>
          <Grid item xs={12} sm style={{ paddingTop: '40px' }}>
            <Typography variant="h6" color="inherit" gutterBottom>
              Liens
            </Typography>
            <Typography paragraph variant="body2" color="inherit">
              <Button size="small" color="inherit" href="https://www.facebook.com/bloodybattle.net/" target="_blank">Facebook</Button>
              <Button size="small" color="inherit" href="https://twitter.com/bloodybattlemc?lang=fr" target="_blank">Twitter</Button>
              <Button size="small" color="inherit" href="https://www.youtube.com/user/sMiLe4460" target="_blank">Youtube</Button><br />
              <Button size="small" color="inherit" href="https://discord.gg/fM5kW7a" target="_blank">Discord</Button>
              <Button size="small" color="inherit" href="#" target="_blank">TeamSpeak</Button>
              <Button size="small" color="inherit" href="http://forum.bloodybattle.net" target="_blank">Forum</Button><br />
              <Button size="small" color="inherit" href="https://shop.bloodybattle.net" target="_blank">Boutique</Button>
              <Button size="small" color="inherit" href="#" target="_blank">Cadeaux</Button>
              <Button size="small" color="inherit" href="#" target="_blank">Contact</Button>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md style={{ paddingTop: '40px' }}>
            <Typography variant="h6" color="inherit" gutterBottom>
              Jeux
            </Typography>
            <Typography paragraph variant="body2" color="inherit">
              <Button size="small" color="inherit">Faction</Button>
              <Button size="small" color="inherit">Skywars</Button>
              <Button size="small" color="inherit">PvPBox</Button>
              <Button size="small" color="inherit">Farm</Button>
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
    <div className="legal">
      <div className="container">
        <Typography variant="caption" color="inherit" style={{ float: 'left', marginBottom: '5px' }}>
          Copyright © 2011-2021 BloodyBattle - Tous droits réservés - 
          <a style={{"color": "white"}} href="https://shop.bloodybattle.net/cgv">Mentions légales</a>
        </Typography>
        <Typography variant="caption" color="inherit" style={{ float: 'right' }}>
          Serveur Minecraft Gratuit non affilié à Mojang 
        </Typography>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/layout/Footer.js